import React from 'react';
import { BrowserRouter, Switch, Route, NavLink, Link, Navbar, Routes, useNavigate, useLocation, useParams } from 'react-router-dom';
import axios from 'axios';

const SuccessfullReservation = () => {
    const navigate = useNavigate();

    const Ok = () => {
        navigate("/OfferRoute");
    }

    return(
        <div className='SuccessfullReservationMainDiv'>
            <h1>Το δρομολόγιο σας διαγράφηκε με επιτυχία!</h1>
            <p>Θα ειδοποιήσουμε τους επιβάτες για την ενέργεια σας</p>
            <div className='SuccessfullButton'>
                <button onClick={Ok}>OK</button>
            </div>
        </div>
    );
}

export default SuccessfullReservation;